module.exports = __webpack_public_path__ + "img/near1.8ab38b6c.jpg";